import { Header } from "@/components/header/Header";
import InnerHero from "@/components/InnerHero/InnerHero";
import { AboutHeritage } from "@/components/AboutPage/AboutHeritage/AboutHeritage";
import { AboutTransparency } from "@/components/AboutPage/AboutTransparency/AboutTransparency";
import { HeritageShowcase } from "@/components/AboutPage/HeritageShowcase/HeritageShowcase";
import { TestimonialsSection } from "@/components/TestimonialsSection/TestimonialsSection";
import { FAQSection } from "@/components/AboutPage/FAQSection/FAQSection";
import { Footer } from "@/components/Footer/Footer";

export default function About() {
  return (
    <main>
      <Header />
        <InnerHero pageKey="about" />
        <AboutHeritage />
        <AboutTransparency />
        <HeritageShowcase />
        <TestimonialsSection />
        <FAQSection />
      
        <Footer />
    </main>
  );
}
